module.exports = __webpack_public_path__ + "img/logo10px.fdcaf6d3.svg";